import { useState } from "react";
import MatchesTab from "./matches/MatchesTab";
import BracketsTab from "./matches/BracketsTab";

const TournamentTabs = ({ tournament, selectedSubcategory }) => {
  const [activeTab, setActiveTab] = useState("partidos");

  return (
    <div className="bg-gray-800 text-white p-4 rounded-lg">
      <div className="flex gap-4 mb-4 border-b border-gray-700">
        <button
          className={`px-4 py-2 ${
            activeTab === "partidos" ? "border-b-2 border-white font-bold" : ""
          }`}
          onClick={() => setActiveTab("partidos")}
        >
          Partidos
        </button>
        <button
          className={`px-4 py-2 ${
            activeTab === "brackets" ? "border-b-2 border-white font-bold" : ""
          }`}
          onClick={() => setActiveTab("brackets")}
        >
          Clasificatorios
        </button>
      </div>

      {activeTab === "partidos" ? (
        <MatchesTab
          tournament={tournament}
          selectedSubcategory={selectedSubcategory}
        />
      ) : (
        <BracketsTab
          tournament={tournament}
          selectedSubcategory={selectedSubcategory}
        />
      )}
    </div>
  );
};

export default TournamentTabs;
